module.exports = __webpack_public_path__ + "static/img/AtWuhu-2.967b1c71.jpg";